/**
 * @function _isTCFAPIAvailable
 * @description Check if TCF API is loaded (yet)
 * @return {boolean}
 */
function _isTCFAPIAvailable(): boolean {
if (typeof(window.__tcfapi) == 'undefined' ||
    !window.__tcfapi) return false;

return true;
}

/**
 * @function getTCFVersion
 * @description Returns the TFC Version
 * @return {number}
 */
export function getTCFVersion(): number {
  // check for TCF API
  if (_isTCFAPIAvailable() === true) {
    let res: number;
    window.__tcfapi('getTCFVersion', 2, (version: string) => {
      res = parseFloat(version);
    }, null);
    if (isNaN(res) === true) {
      throw new Error(`TCF Version is NaN; should be a floating number, like 1.1 or 2.0`);
    }

    return res;
  }

  return 1.1;
}
